import Apply from "../Steps/Apply";
import NZPassport from "../Steps/NZPassport";
import BirthCertificate from "../Steps/Birthcertificate.tsx";
import Passport from "../Steps/Passport.tsx";
import RequestChange from "../Steps/RequestChange.tsx";
import ReviewPassport from "../Steps/ReviewPassport";
import ReviewBirthDetails from "../Steps/ReviewBirthDetails";
import PreLiveCheck from "../Steps/PreLiveCheck";
import PostLiveCheck from "../Steps/PostLiveCheck";
import PreReferee from "../Steps/PreReferee";
import RefereeDetails from "../Steps/RefereeDetails.tsx";
import ApplicationSubmit from "../Steps/ApplicationSubmit";
import NoPhotoVerification from "../Steps/NoPhotoVerification";
import PhotoVerificationFailed from "../Steps/PhotoVerificationFailed.jsx";
import PhotoVerificationFailedNoRetry from "../Steps/PhotoVerificationFailedNoRetry.jsx";
import ApplicationAtStore from "../Steps/ApplicationAtStore";
import Citizenship from "../Steps/Citizenship.tsx";
import ReviewCitizenship from "../Steps/ReviewCitizenship";
import Immigration from "../Steps/Immigration.tsx";
import SavedApplication from "../Steps/SavedApplication";
import PendingVerification from "../Steps/PendingVerification";
import RenewIdentity from "../Steps/RenewIdentity";
import MyIdentity from "../Steps/MyIdentity";
import Inactive from "../Steps/Inactivity";
import NZBorn from "../Steps/Born";
import ReviewImmigration from "../Steps/ReviewImmigration";
import NZCitizen from "../Steps/NZCitizen";
import TokenSaver from "../Auth/TokenSaver";
import AttemptsExhausted from "../Steps/Error/AttemptsExhausted";
import PhotoID from "../Steps/PhotoId.tsx";
import ReviewRenew from "../Steps/ReviewRenew.jsx";
import SomethingWrong from "../Steps/Error/SomethingWrong.jsx";
import SomethingWrongUpgrade from "../Steps/Error/SomethingWrongUpgrade.jsx";
import TestError from "../Steps/Error/TestError.jsx";
import MySharedInformation from "../Steps/MySharedInformation.jsx";
import CancelSubmit from "../Steps/CancelSubmit.jsx";
import IdentityUpdateSubmit from "../Steps/IdentityUpdateSubmit.jsx";
import SessionExpiry from "../Steps/SessionExpiry.jsx";

const base = "/app/";

const steps = {
  [`${base}`]: {
    component: TokenSaver,
    progress: 10,
    showProgress: false,
    nextYes: `${base}nzpassport`,
    back: `${base}`,
  },
  [`${base}apply`]: {
    component: Apply,
    progress: 10,
    showProgress: true,
    nextYes: `${base}nzpassport`,
    back: `${base}nzpassport`,
  },
  [`${base}renew-identity`]: {
    component: RenewIdentity,
    nextYes: `${base}request-change-renew`,
    progress: 10,
    showProgress: true,
  },
  [`${base}nzpassport`]: {
    component: NZPassport,
    progress: 10,
    showProgress: true,
    nextYes: `${base}passport`,
    back: `${base}nzborn`,
  },
  [`${base}passport`]: {
    component: Passport,
    progress: 7,
    showProgress: true,
    nextYes: `${base}request-change-passport`,
  },
  [`${base}nzborn`]: {
    component: NZBorn,
    progress: 7,
    showProgress: true,
    nextYes: `${base}birth-certificate`,
    back: `${base}nzcitizen`,
  },
  [`${base}nzcitizen`]: {
    component: NZCitizen,
    progress: 7,
    showProgress: true,
    nextYes: `${base}citizenship`,
    back: `${base}immigration`,
  },
  [`${base}birth-certificate`]: {
    component: BirthCertificate,
    progress: 7,
    showProgress: true,
    nextYes: `${base}request-change-birth`,
  },
  [`${base}request-change-passport`]: {
    component: RequestChange,
    progress: 7,
    showApplication: true,
    showProgress: true,
    nextYes: `${base}review-passport`,
  },
  [`${base}review-renew`]: {
    component: ReviewRenew,
    progress: 7,
    showApplication: true,
    showProgress: true,
    nextYes: `${base}pre-live-check`,
  },
  [`${base}request-change-renew`]: {
    component: RequestChange,
    progress: 7,
    showApplication: true,
    showProgress: true,
    nextYes: `${base}review-renew`,
  },
  [`${base}request-change-birth`]: {
    component: RequestChange,
    progress: 7,
    showApplication: true,
    showProgress: true,
    nextYes: `${base}review-birth`,
  },
  [`${base}review-passport`]: {
    component: ReviewPassport,
    progress: 7,
    showProgress: true,
    nextYes: `${base}pre-live-check`,
  },
  [`${base}review-birth`]: {
    component: ReviewBirthDetails,
    progress: 7,
    showProgress: true,
    nextYes: `${base}pre-live-check`,
  },
  [`${base}pre-live-check`]: {
    component: PreLiveCheck,
    progress: 7,
    showProgress: true,
  },
  [`${base}post-live-check`]: {
    component: PostLiveCheck,
    progress: 4,
    nextYes: `${base}application-submit`,
    showProgress: true,
  },
  [`${base}pre-referee`]: {
    component: PreReferee,
    progress: 4,
    showProgress: true,
    nextYes: `${base}referee-details`,
  },
  [`${base}referee-details`]: {
    component: RefereeDetails,
    progress: 4,
    showProgress: true,
    nextYes: `${base}application-submit`,
    nextNo: `${base}pre-live-check`,
  },
  [`${base}application-submit`]: {
    component: ApplicationSubmit,
    progress: 0,
    showProgress: true,
    statusText: "Done",
  },
  [`${base}no-photo-verification`]: {
    component: NoPhotoVerification,
    progress: 6,
    nextYes: `${base}photo-id`,
    showProgress: true,
  },
  [`${base}photo-verification-failed`]: {
    component: PhotoVerificationFailed,
    progress: 6,
    nextYes: `${base}photo-id`,
    showProgress: true,
  },
  [`${base}photo-verification-failed-no-retry`]: {
    component: PhotoVerificationFailedNoRetry,
    progress: 6,
    nextYes: `${base}photo-id`,
    showProgress: true,
  },
  [`${base}application-at-store`]: {
    component: ApplicationAtStore,
    progress: 0,
    showProgress: true,
  },
  [`${base}photo-id`]: {
    component: PhotoID,
    progress: 7,
    showProgress: true,
    nextYes: `${base}application-at-store`,
  },
  [`${base}citizenship`]: {
    component: Citizenship,
    progress: 7,
    showProgress: true,
    nextYes: `${base}request-change-citizenship`,
  },
  [`${base}request-change-citizenship`]: {
    component: RequestChange,
    progress: 7,
    showApplication: true,
    showProgress: true,
    nextYes: `${base}review-citizenship`,
  },
  [`${base}review-citizenship`]: {
    component: ReviewCitizenship,
    progress: 4,
    showProgress: true,
    nextYes: `${base}pre-live-check`,
  },
  [`${base}immigration`]: {
    component: Immigration,
    progress: 7,
    nextYes: `${base}request-change-immigration`,
    showProgress: true,
  },
  [`${base}request-change-immigration`]: {
    component: RequestChange,
    progress: 7,
    showApplication: true,
    showProgress: true,
    nextYes: `${base}review-immigration`,
  },
  [`${base}review-immigration`]: {
    component: ReviewImmigration,
    progress: 7,
    showProgress: true,
    nextYes: `${base}pre-live-check`,
  },
  [`${base}saved-application`]: {
    component: SavedApplication,
    progress: 7,
    showProgress: false,
  },
  [`${base}pending-verification`]: {
    component: PendingVerification,
    progress: 10,
    showProgress: true,
  },
  [`${base}my-identity`]: {
    component: MyIdentity,
    progress: 10,
    showProgress: false,
  },
  [`${base}session-timeout`]: {
    component: Inactive,
    progress: 10,
    showProgress: false,
  },
  [`${base}session-expiry`]: {
    component: SessionExpiry,
    progress: 10,
    showProgress: false,
  },
  [`${base}attempts-exhausted`]: {
    component: AttemptsExhausted,
    progress: 10,
    showProgress: false,
  },
  [`${base}something-went-wrong`]: {
    component: SomethingWrong,
    progress: 10,
    showProgress: false,
  },
  [`${base}something-went-wrong-upgrade`]: {
    component: SomethingWrongUpgrade,
    progress: 10,
    showProgress: false,
  },
  [`${base}test-error`]: {
    component: TestError,
    progress: 10,
    showProgress: false,
  },
  [`${base}my-shared-info`]: {
    component: MySharedInformation,
    progress: 10,
    showProgress: false,
  },
  [`${base}cancel-identity`]: { component: CancelSubmit, showProgress: false },
  [`${base}request-change-identity`]: {
    component: RequestChange,
    progress: 7,
    showApplication: true,
    showProgress: false,
    nextYes: `${base}update-identity-submit`,
  },
  [`${base}update-identity-submit`]: {
    component: IdentityUpdateSubmit,
    progress: 0,
    showProgress: false,
    statusText: "Done",
    nextYes: `${base}my-identity`,
  },
};

export default steps;
